import { useEffect, useState } from "react";
import styled from "styled-components";
import { useNavigate } from "react-router-dom";
import { useSearchParams } from "react-router-dom";

import * as css from "styles/CssVariables.js";
import globalConstants from "constants/globalConstants";
import Layout from "components/Layout";
import PageTitle from "components/text/PageTitle";
import RoundActionIcon from "components/buttons/RoundActionIcon";
import AutoresponderMessagesContainer from "./AutoresponderMessagesContainer";

import returnIcon from "assets/img/icons/return-icon.svg";
import AutoresponderDataContainer from "./AutoresponderDataContainer";
import SentResponderEmailsContainer from "components/autoresponder/SentResponderEmailsContainer";
import AutoresponderSubscribersContainer from "./AutoresponderSubscribersContainer";

const Autoresponder = styled.div`
  position: relative;
  width: 100%;
  box-sizing: border-box;

  margin: 0 0 50px;
  padding: 0 28px;

  display: flex;
  flex-direction: column;

  @media (max-width: ${globalConstants.switchTablet}) {
    margin: 0;
    padding: 0;
  }
`;

export default () => {
  const navigate = useNavigate();

  const [searchParams] = useSearchParams();

  // set page Title
  useEffect(() => {
    document.title = "Autoresponder | Scalelup";
  }, []);

  const autoresponderId = searchParams.get("id")
    ? searchParams.get("id")
    : null;

  return (
    <Layout>
      <Autoresponder>
        <AutoresponderDataContainer autoresponderId={autoresponderId} />
        <AutoresponderMessagesContainer autoresponderId={autoresponderId} />
        <AutoresponderSubscribersContainer autoresponderId={autoresponderId} />
        <SentResponderEmailsContainer autoresponderId={autoresponderId} />
      </Autoresponder>
    </Layout>
  );
};
